import { useSWRConfig } from 'swr'

export const useClearMyProjectListCache = () => {
  const { mutate } = useSWRConfig()

  return {
    clear: () => {
      mutate(
        (key) => typeof key === 'string' && key.startsWith('/api/me/projects'),
        undefined,
        { revalidate: true },
      )
    },
  }
}

export const useClearCreationLibraryCache = () => {
  const { mutate } = useSWRConfig()

  return {
    clear: () =>
      mutate(
        (key) => {
          return (
            typeof key === 'string' &&
            key.startsWith('/api/me/assets?source=creation')
          )
        },
        undefined,
        { revalidate: true },
      ),
  }
}

export const useClearShareProjectCache = () => {
  const { mutate } = useSWRConfig()

  return {
    clear: () =>
      mutate('/api/me/project/share', undefined, { revalidate: true }),
  }
}
